import { lazy } from "react";
import i18n from "i18next";
import type { PuzzleTypeModule } from "../types";
import { registerRushTranslations } from "./i18n";
import { emptyDefinition, emptyProgress, migrateProgress, serializeSubmission } from "./progress";
import { emptySolution } from "./solution";
import type { RushDefinition, RushProgress, RushSolution, RushSubmission } from "./types";

registerRushTranslations(i18n);

/** No `localFeedback`: every slide can be taken back, so no position is ever lost. */
export const rushHourModule: PuzzleTypeModule<
  RushDefinition,
  RushSubmission,
  RushProgress,
  RushSolution
> = {
  key: "rush_hour",
  Player: lazy(() => import("./Player")),
  Editor: lazy(() => import("./Editor")),
  SolutionEditor: lazy(() => import("./SolutionEditor")),
  PrintView: lazy(() => import("./PrintView")),
  emptyDefinition,
  emptyProgress,
  migrateProgress,
  serializeSubmission,
  emptySolution,
};
